/* ============================================================
   MIYAGEN 商品ギャラリー: メイン画像の自動スライド (2026-08-13)

   仕様:
   - 4 秒ごとに次の画像へ横スライド。最後まで行ったら先頭へ戻る
   - ユーザーが操作したら（スワイプ / 前後ボタン / サムネ / 端タップ / キー操作）自動送りは停止
   - タブが非表示の間・ギャラリーが画面外の間は一時停止（戻ったら再開）
   - ホバーでは止めない（カーソルが乗っているだけで進まず「遅い」と感じるため 2026-08-13 廃止）
   - メイン画像の左右の端をタップ/クリックで 1 枚送る
   - OS の「視差効果を減らす」設定が有効なら自動送りしない

   対象: gallery_layout = thumbnail のギャラリー（.product--thumbnail 配下）
   関連: assets/miyagen-product-gallery.css / assets/media-gallery.js
   ============================================================ */

(function () {
  'use strict';

  var AUTOPLAY_INTERVAL = 4000;

  function MiyagenGalleryAutoplay(gallery) {
    this.gallery = gallery;
    this.viewer = gallery.querySelector('[id^="GalleryViewer"]');
    this.slider = this.viewer ? this.viewer.querySelector('[id^="Slider-Gallery"]') : null;
    this.timer = null;
    this.stopped = false;
    this.offscreen = false;

    if (!this.slider) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    // 読み込み時点でレイアウトが確定していない（幅0）ことがあるため、
    // その場合は幅がついてから初期化する。ここで諦めると自動送りが起動しないままになる。
    if (this.visibleItems().length < 2) {
      if (!('ResizeObserver' in window)) return;
      var self = this;
      var ro = new ResizeObserver(function () {
        if (self.visibleItems().length < 2) return;
        ro.disconnect();
        self.bind();
        self.start();
      });
      ro.observe(this.slider);
      return;
    }

    this.bind();
    this.start();
  }

  MiyagenGalleryAutoplay.prototype.visibleItems = function () {
    return Array.prototype.filter.call(
      this.slider.querySelectorAll('.product__media-item'),
      function (el) {
        return el.clientWidth > 0;
      }
    );
  };

  MiyagenGalleryAutoplay.prototype.bind = function () {
    var self = this;

    // --- ユーザー操作を検知したら以降は自動送りしない ---
    var stop = function () {
      self.stop();
    };
    // スワイプ / クリック / タップ（前後ボタン・サムネ列も含む）
    // capture で拾う。サムネ列を指でスライドし始めた瞬間に確実に止めたいため、
    // 途中で伝播が止められても取りこぼさないようにする。
    ['pointerdown', 'touchstart', 'touchmove'].forEach(function (type) {
      self.gallery.addEventListener(type, stop, { passive: true, capture: true });
    });
    this.gallery.addEventListener('keydown', stop, { capture: true });
    // 横方向のホイール・トラックパッド操作のみ（縦のページスクロールでは止めない）
    this.slider.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) self.stop();
      },
      { passive: true }
    );

    // --- 一時停止（操作ではないので再開する） ---
    // ホバーでの一時停止はしない。カーソルが画像の上に乗っているだけで止まり、
    // 眺めている間ずっと進まず「間延びして遅い」と感じるため（2026-08-13 廃止）。
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.clearTimer();
      } else {
        self.start();
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          self.offscreen = !entries[0].isIntersecting;
          if (self.offscreen) {
            self.clearTimer();
          } else {
            self.start();
          }
        },
        { threshold: 0.2 }
      ).observe(this.slider);
    }
  };

  MiyagenGalleryAutoplay.prototype.start = function () {
    if (this.stopped || this.timer || document.hidden || this.offscreen) return;
    var self = this;
    this.timer = window.setInterval(function () {
      self.tick();
    }, AUTOPLAY_INTERVAL);
  };

  MiyagenGalleryAutoplay.prototype.clearTimer = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  MiyagenGalleryAutoplay.prototype.stop = function () {
    this.stopped = true;
    this.clearTimer();
  };

  MiyagenGalleryAutoplay.prototype.tick = function () {
    if (this.stopped || this.offscreen || document.hidden) return;

    var items = this.visibleItems();
    if (items.length < 2) return;

    // 現在位置に最も近いスライドを求め、その次へ
    var scrollLeft = this.slider.scrollLeft;
    var currentIndex = 0;
    var smallestDelta = Infinity;
    for (var i = 0; i < items.length; i++) {
      var delta = Math.abs(items[i].offsetLeft - scrollLeft);
      if (delta < smallestDelta) {
        smallestDelta = delta;
        currentIndex = i;
      }
    }

    var next = items[(currentIndex + 1) % items.length];
    this.slider.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
  };

  /* ------------------------------------------------------------
     前後ボタンの端判定の補正

     Rise コアの SliderComponent.isSlideVisible() は clientWidth(整数丸め)と
     scrollLeft(小数)を比較するため、最後の1枚まで送っても 0.5px 足りず
     「まだ先がある」と誤判定し、「次へ」が押せるまま残る（実測 左辺11584 / 右辺11583.5）。
     ギャラリーのメインスライダーに限り、2px の許容を持たせて上書きする。
     コアの scroll リスナーより後に登録されるので、こちらの判定が最終値になる。
     ------------------------------------------------------------ */
  function fixEdgeButtons(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var slider = viewer.querySelector('[id^="Slider-Gallery"]');
    var prev = viewer.querySelector('button[name="previous"]');
    var next = viewer.querySelector('button[name="next"]');
    var buttons = viewer.querySelector('.slider-buttons');
    if (!slider || !prev || !next) return;

    var EDGE = 2;
    var sync = function () {
      // 画像が1枚だけの商品では前後ボタンと「1 / 1」カウンターごと隠す
      if (buttons) {
        buttons.classList.toggle(
          'miyagen-slider-buttons-hidden',
          slider.querySelectorAll('.product__media-item').length < 2
        );
      }
      var max = slider.scrollWidth - slider.clientWidth;
      prev.disabled = slider.scrollLeft <= EDGE;
      next.disabled = max <= EDGE || slider.scrollLeft >= max - EDGE;
    };

    slider.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------------------
     メイン画像の左右の端をタップ/クリックで 1 枚送る

     SP には前後ボタンが無いので、スワイプ以外の送り方を用意する。
     PC でも同じ操作ができる（カーソルの形で送れる位置を示す）。

     ・端から 22% を判定領域にする（中央 56% は反応しない）
     ・スワイプ/ドラッグだったときは送らない（押した位置から 10px 以上動いた場合）
     ・端では止まる。前後ボタンの活性状態やカウンターと挙動を揃えるため、
       最後→最初 のループはしない
     ------------------------------------------------------------ */
  function edgeTapNavigation(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var slider = viewer.querySelector('[id^="Slider-Gallery"]');
    if (!slider) return;

    var EDGE_RATIO = 0.22;
    var MOVE_TOLERANCE = 10;
    var down = null;

    var visibleItems = function () {
      return Array.prototype.filter.call(
        slider.querySelectorAll('.product__media-item'),
        function (el) {
          return el.clientWidth > 0;
        }
      );
    };

    var step = function (dir) {
      var items = visibleItems();
      if (items.length < 2) return;
      var current = 0;
      var smallest = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - slider.scrollLeft);
        if (d < smallest) {
          smallest = d;
          current = i;
        }
      }
      var target = current + dir;
      if (target < 0 || target > items.length - 1) return; // 端では何もしない
      slider.scrollTo({ left: items[target].offsetLeft, behavior: 'smooth' });
    };

    var zoneOf = function (clientX) {
      var rect = slider.getBoundingClientRect();
      if (!rect.width) return 0;
      var x = clientX - rect.left;
      if (x < rect.width * EDGE_RATIO) return -1;
      if (x > rect.width * (1 - EDGE_RATIO)) return 1;
      return 0;
    };

    slider.addEventListener(
      'pointerdown',
      function (event) {
        down = { x: event.clientX, y: event.clientY, scroll: slider.scrollLeft };
      },
      { passive: true }
    );

    slider.addEventListener('click', function (event) {
      if (!down) return;
      var moved =
        Math.abs(event.clientX - down.x) > MOVE_TOLERANCE ||
        Math.abs(event.clientY - down.y) > MOVE_TOLERANCE ||
        Math.abs(slider.scrollLeft - down.scroll) > 5;
      down = null;
      if (moved) return; // スワイプだったので送らない
      var dir = zoneOf(event.clientX);
      if (dir) step(dir);
    });

    // PC では送れる位置にカーソルで気づけるようにする
    slider.addEventListener('mousemove', function (event) {
      var dir = zoneOf(event.clientX);
      var cursor = dir === -1 ? 'w-resize' : dir === 1 ? 'e-resize' : '';
      if (slider.style.cursor !== cursor) slider.style.cursor = cursor;
    });
    slider.addEventListener('mouseleave', function () {
      slider.style.cursor = '';
    });
  }

  function init() {
    document.querySelectorAll('.product--thumbnail media-gallery').forEach(function (gallery) {
      if (gallery.miyagenGalleryReady) return;
      gallery.miyagenGalleryReady = true;
      fixEdgeButtons(gallery);
      edgeTapNavigation(gallery);
      gallery.miyagenAutoplay = new MiyagenGalleryAutoplay(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
